import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LandfillOperatorEntry } from "@/pages/dashboard/landfill/Landfill";

export default function LandfillWorkspace() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (["admin", "office", "super_admin"].includes(user?.role)) return <Outlet />;
  if (user?.role === "field" && user.landfill_operator === true &&
      ["/app/landfill", "/app/landfill/loads"].includes(pathname.replace(/\/$/, ""))) {
    return <LandfillOperatorEntry />;
  }
  return <Navigate to="/app" replace />;
}
